import {getMethod, putMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/pspSettings', request)
}

async function put(pspId, request) {
    return await putMethod(`/api/pspSettings/${pspId}`, request)
}

export {get, put}
